module.exports = __webpack_public_path__ + "static/img/linda_sad.65fba4e.png";